<template>
    <div class="absolute z-50 w-full h-screen 
                overflow-hidden bg-gray-transition-20
                justify-center items-center"
         :class="{'hidden': !isPopupActive, 'flex': isPopupActive}"
    >
        <div class="w-[600px] h-[520px] bg-white rounded-md flex flex-col">
            <div class="w-full flex items-start justify-start mt-5">
                <div class="w-full flex justify-center items-center font-bold text-xl h-10">
                    Настройки рабочего потока
                </div>
                <div class="flex justify-center items-center
                        font-bold text-xl cursor-pointer
                        hover:bg-gray-100 transition-all duration-150 ease-in
                        w-10 h-10 rounded-full mr-5"
                     v-on:click="closeModal"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </div>
            </div>
            <FrequencyStartSettings class="mx-auto my-auto" v-model="isPopupActive" />

        </div>

    </div>
</template>

<script setup>
    import { defineModel } from 'vue';
    import FrequencyStartSettings from "@/pages/Flow/FrequencyStartSettings.vue";

    const isPopupActive = defineModel('is-active')


    function closeModal() {
        isPopupActive.value = false
    }

</script>

<style scoped>
    .bg-gray-transition-20 {
        background-color: rgba(85, 85, 85, 0.2);
    }
</style>